import Reveal from "./Reveal";
import Faq from "./Faq";
import { GENERAL_FAQS } from "../data/content";

export default function FaqSection() {
  return (
    <section id="duvidas" data-testid="faq-section" className="relative bg-navy-900 py-24 sm:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 sm:px-8 lg:grid-cols-[0.8fr_1.2fr]">
        <Reveal>
          <p className="font-mono-meta text-[11px] uppercase tracking-[0.35em] text-gold-400">Dúvidas frequentes</p>
          <h2 className="font-display mt-5 text-4xl font-medium leading-tight text-cream sm:text-5xl">
            Antes de <em className="gold-text">conversar</em>
          </h2>
          <p className="mt-5 max-w-sm text-base leading-relaxed text-mist">
            Respostas rápidas sobre como funciona o atendimento. Dúvidas sobre o seu caso? Fale com a gente pelo
            WhatsApp.
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <Faq items={GENERAL_FAQS} testId="general-faq" />
        </Reveal>
      </div>
    </section>
  );
}
